import CoreBase from '../../services/engines/CoreBase';
import userSettingsService from '../../services/UserSettingsService';

const _name = 'UserSettingsSaver';

/**
 * Saves user settings to Gateway.
 */
class UserSettingsSaver extends CoreBase {
    _name = _name;

    /**
     * Saves a single user setting.
     * @param {string} key
     * @param {*} value
     */
    save = async (key, value) => {
        try {
            await userSettingsService.postUserSetting(key, value);
        } catch (error) {
            this.logError('save', `key=${key} error=${error.message}`);
        }
    };
}

const userSettingsSaver = new UserSettingsSaver();
export default userSettingsSaver;
